import AvatarCat from "./AvatarCat";
export default AvatarCat;
